import React from "react";
import { X, Link2 } from "lucide-react";
import { siteNameFromUrl } from "../utils/linkEmbed";

// A pasted link rendered as a small pill showing its site name (e.g.
// "canva.com") instead of the raw URL, with an optional caption underneath.
// Clicking the pill opens the real link in a new tab. Pass `onRemove` to show
// a remove (X) button — omit it for read-only display (detail panels).
export function EmbedPill({ url, description, onRemove }) {
  const siteName = siteNameFromUrl(url);
  return (
    // alignItems:"flex-start" (not the flex-column default "stretch") keeps the
    // pill's own width independent of the caption below it — otherwise a long
    // description would stretch the pill out to match its width. maxWidth caps
    // the caption so it wraps onto multiple lines instead of running on forever.
    <div style={{ display: "inline-flex", flexDirection: "column", alignItems: "flex-start", gap: 4, maxWidth: 240 }}>
      <div style={{
        display: "inline-flex", alignItems: "center", gap: 6, flexShrink: 0,
        background: "var(--c-bg-soft)", border: "1.5px solid #f0c8e0", borderRadius: 20,
        padding: onRemove ? "4px 6px 4px 12px" : "5px 14px",
      }}>
        <a href={url} target="_blank" rel="noopener noreferrer"
          style={{ display: "flex", alignItems: "center", gap: 5, textDecoration: "none", color: "#d4789a", fontWeight: 700, fontSize: 12, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 150 }}>
          <Link2 size={12} style={{ flexShrink: 0 }} />
          <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>{siteName}</span>
        </a>
        {onRemove && (
          <button onClick={onRemove}
            style={{ background: "none", border: "none", cursor: "pointer", color: "var(--c-text-soft)", padding: 2, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, alignSelf: "center" }}>
            <X size={13} />
          </button>
        )}
      </div>
      {description && (
        <span style={{ fontSize: 13, fontWeight: 600, color: "var(--c-text-soft)", paddingLeft: 4, wordBreak: "break-word", maxWidth: 240 }}>{description}</span>
      )}
    </div>
  );
}
